(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.afZA = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'Nou',
        today: 'Vandag',
        cancel: 'Kanselleer',
        clear: 'Maak skoon',
        confirm: 'Bevestig',
        selectDate: 'Kies datum',
        selectTime: 'Kies tyd',
        startDate: 'Begindatum',
        startTime: 'Begintyd',
        endDate: 'Einddatum',
        endTime: 'Eindtyd',
        prevYear: 'Previous Year',
        // to be translated
        nextYear: 'Next Year',
        // to be translated
        prevMonth: 'Previous Month',
        // to be translated
        nextMonth: 'Next Month',
        // to be translated
        year: 'Jaar',
        month1: 'Jan',
        month2: 'Feb',
        month3: 'Mrt',
        month4: 'Apr',
        month5: 'Mei',
        month6: 'Jun',
        month7: 'Jul',
        month8: 'Aug',
        month9: 'Sep',
        month10: 'Okt',
        month11: 'Nov',
        month12: 'Des',
        weeks: {
          sun: 'So',
          mon: 'Ma',
          tue: 'Di',
          wed: 'Wo',
          thu: 'Do',
          fri: 'Vr',
          sat: 'Sa'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mrt',
          apr: 'Apr',
          may: 'Mei',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Des'
        },
        pickADay: 'Select a day'
      },
      select: {
        loading: 'Laai',
        noMatch: 'Geen toepaslike data',
        noData: 'Geen data',
        placeholder: 'Kies'
      },
      pagination: {
        goto: 'Gaan na',
        pagesize: '/page',
        total: 'Totaal {total}',
        pageClassifier: ''
      },
      upload: {
        deleteTip: 'press delete to remove',
        // to be translated
        delete: 'Verwyder',
        preview: 'Voorskou',
        continue: 'Gaan voort'
      },
      table: {
        emptyText: 'Geen Data',
        confirmFilter: 'Bevestig',
        resetFilter: 'Herstel',
        clearFilter: 'Alles',
        sumText: 'Som'
      },
      tree: {
        emptyText: 'Geen Data'
      }
    }
  };
  _exports.default = _default;
});